import { createFileRoute, redirect } from '@tanstack/react-router';
import { ShareableLinkPage } from '../components/profile/settings/ShareableLinkPage';

export const Route = createFileRoute('/profile/settings/shareable-link')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: ShareableLinkPage,
});
